
import {
  GET_OFFLINE_SUCCESS,
  GET_OFFLINEPAYMENT_LOADING,
  GET_OFFLINE_FAIL,
  GET_ALLOFFLINE_SUCCESS,
  GET_ALLOFFLINEPAYMENT_LOADING,
  GET_ALLOFFLINE_FAIL

} from "./types";

const initialState = {
  loading: false,
  offlinePaymentCreate: {},
  error: null,
  getOfflinePayment:[],
 
};

const offlinePaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case GET_OFFLINEPAYMENT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case  GET_OFFLINE_SUCCESS:
      return {
        ...state,
        loading: false,
        offlinePaymentCreate: action.payload,
        error: null,
      };
    case GET_OFFLINE_FAIL:
      return {
        ...state,
        loading: false,
        offlinePaymentCreate: null,
        error: action.payload,
      };
  
    case GET_ALLOFFLINEPAYMENT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case  GET_ALLOFFLINE_SUCCESS:
      return {
        ...state,
        loading: false,
        getOfflinePayment: action.payload,
        error: null,
      };
    case GET_ALLOFFLINE_FAIL:
      return {
        ...state,
        loading: false,
        getOfflinePayment: null,
        error: action.payload,
      };
  


    default:
      return state;
  }
};
export default offlinePaymentReducer;
